// import React, { useContext } from 'react';
import { useContext } from 'react';
// import { Route } from 'react-router-dom';//, Navigate
import { UserContext } from '../../hooks/UserContext';
import Loading from '../Loading';

import Erro404 from "../../pages/Pagina404";


// Rotas para ADMs
export default function ARoute(props) {
    const { user, isLoading } = useContext(UserContext);
    // console.log("AR user", user, isLoading);

    const { children, patente:pp } = props;
    const patente = Number(pp) ? pp : 3

    // PAGINA DE CARREGAMENTO (aguardando enquanto usuario é carregado)
    if (isLoading) {
        return (<Loading/>)
    }
    //<<patente>>+professor
    if(!!user && user.patente>=patente){
        // SE USUARIO está autorizado: então carrega a página em component
        // return ( <Route {...rest} render={(props) => (<Component {...props}/>)}/>)
        return (children)
    } else {
        // SE USUARIO não está autorizado: então carrega a página de erro 404
        // return ( <Route {...rest} render={(_) => (<Erro404/>)}/>)
        return (<Erro404/>)
        // return (<Navigate to='/404'/>)
    }

}
